import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const OrderMngPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Grade</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Color</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Packaginng</th>
                                    {/* <th className="min-w-100px">Purchase Order</th> */}
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Quantity (Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.confirmedOrderDetails[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    {/* <td>
                                        {user.paymentInfo?.images?.[0]?.docUrl ? (
                                            <a
                                                href={user?.paymentInfo?.images[0].docUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-center d-flex flex-column align-items-center"
                                            >
                                                <i className="bi bi-file-pdf text-danger" style={{ fontSize: '3rem' }}></i>
                                                <span className="text-dark fw-semibold mt-2">View Order Document</span>
                                            </a>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    {/* New Payment Details Table */}
                    <div className="table-responsive mt-8">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Rate (INR/Kg)</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Advance Amount (INR)</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>UTR Number</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Payment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.confirmedOrderDetails[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.paymentInfo?.amount || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.paymentInfo?.paymentId || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.paymentInfo?.updatedAt ?
                                                new Date(user.paymentInfo.updatedAt).toLocaleString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: '2-digit'
                                                }).replace(/\//g, '/')
                                                : 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>



                    <div className="table-responsive mt-8">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Material Information</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Purchase Document</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Purchase Order</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user.images?.some(img => img.docType === 'MATERIAL_DOC') ? (
                                            <a
                                                href={user.images.find(img => img.docType === 'MATERIAL_DOC')?.docUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-center d-flex flex-column align-items-center"
                                            >
                                                <i className="bi bi-file-pdf text-danger" style={{ fontSize: '3rem' }}></i>
                                                <span className="text-dark fw-semibold mt-2">View Material Document</span>
                                            </a>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user.images?.some(img => img.docType === 'PURCHASE_DOC') ? (
                                            <a
                                                href={user.images.find(img => img.docType === 'PURCHASE_DOC')?.docUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-center d-flex flex-column align-items-center"
                                            >
                                                <i className="bi bi-file-pdf text-danger" style={{ fontSize: '3rem' }}></i>
                                                <span className="text-dark fw-semibold mt-2">View Purchase Document</span>
                                            </a>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user.paymentInfo?.images?.[0]?.docUrl ? (
                                            <a
                                                href={user?.paymentInfo?.images[0].docUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-center d-flex flex-column align-items-center"
                                            >
                                                <i className="bi bi-file-pdf text-danger" style={{ fontSize: '3rem' }}></i>
                                                <span className="text-dark fw-semibold mt-2">View Order Document</span>
                                            </a>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>




                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};